import React from 'react';
import '../styles/InfoPlans.css';
import '../styles/Content.css';

function InfoPlans({ sectionTitle, sectionDescription, items }) {
  return (
    <section className="content-container">
      {/* Section Title & Description */}
      {sectionTitle && <h2 className="content-header">{sectionTitle}</h2>}
      {sectionDescription && <p className="content-description">{sectionDescription}</p>}

      {/* Info Modal Section */}
      <div className="info-modal">
        {items.map((item, index) => (
          <div className="info-item" key={index}>
            <h3 className="info-title">{item.title}</h3>
            <p className="info-description">{item.description}</p>
            {index < items.length - 1 && <div className="vertical-line"></div>}
          </div>
        ))}
      </div>
    </section>
  );
}

export default InfoPlans;